import React from 'react';
import { twMerge } from 'tailwind-merge';

const styles = {
  success: 'bg-spring-green/10 text-spring-green',
  error: 'bg-bittersweet/10 text-bittersweet',
  warning: 'bg-celadon/10 text-violet',
  info: 'bg-sky-blue/10 text-sky-blue'
};

const sizes = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-1',
  lg: 'text-base px-3 py-1.5'
};

export default function Badge({ 
  children, 
  variant = 'info', 
  size = 'md',
  className = '' 
}) {
  return (
    <span className={twMerge(
      'inline-flex items-center font-medium rounded-pill',
      styles[variant],
      sizes[size],
      className
    )}>
      {children}
    </span>
  );
}